import React from "react";

import Band from "./Icons/Band";
import Luggage from "./Icons/Luggage";
import Puzzle from "./Icons/Puzzle";
import Segment from "./Icons/Segment";
import Strings from "./Icons/Strings";

// Configure our tabs and tab content here
const tabs = [
  {
    title: "Segments",
    subTitle: "Event Timing",
    id: "segment",
    icon: <Segment />,
    price: 0,
    barHeights: [120, 100, 80, 60, 40],
    skip: true,
  },
  {
    title: "Band",
    subTitle: "Configuration",
    id: "band",
    icon: <Band />,
    price: 0,
    barHeights: [120, 100, 80, 60, 40],
    skip: true,
  },
  {
    title: "Strings",
    subTitle: "E.V.E",
    id: "strings",
    icon: <Strings />,
    price: 0,
    barHeights: [80, 80, 80, 80, 80],
    skip: true,
  },
  {
    title: "Travel",
    subTitle: "Cost",
    id: "travel",
    icon: <Luggage />,
    price: 0,
    barHeights: [40, 60, 80, 100, 120],
    skip: true,
  },
  {
    title: "Extras",
    subTitle: "",
    id: "extra",
    icon: <Puzzle />,
    price: 0,
    barHeights: [40, 60, 80, 100, 120],
    skip: false,
  },
];

export default tabs;
